// ============================================================
// A RIM ROUND THE SILHOUETTE (plan body-map T2): its alpha grown outward by
// a radius, the inside cut away, flooded in a token's colour - Fear's rims,
// the void's cold edge, Frenzied's tensed outline, Incorporeal's bright one
// (which glows it after: `children` run on the rim, `result="o"`).
// ============================================================

import type { ReactNode } from 'react';

interface Props {
  id: string;
  /** How far the rim stands out from the silhouette (frame units). */
  radius: number;
  /** The class that floods it (its colour is a token). */
  flood: string;
  children?: ReactNode;
}

export function OutlineFilter({ id, radius, flood, children }: Props) {
  return (
    <filter id={id} x="-5%" y="-5%" width="110%" height="110%">
      <feMorphology in="SourceAlpha" operator="dilate" radius={radius} result="d" />
      <feComposite in="d" in2="SourceAlpha" operator="out" result="e" />
      <feFlood className={flood} />
      <feComposite in2="e" operator="in" result="o" />
      {children}
    </filter>
  );
}
